import { render, staticRenderFns } from "./Bible.vue?vue&type=template&id=ba677c68&scoped=true&"
import script from "./Bible.vue?vue&type=script&lang=js&"
export * from "./Bible.vue?vue&type=script&lang=js&"
import style0 from "./Bible.vue?vue&type=style&index=0&id=ba677c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba677c68",
  null
  
)

export default component.exports